module.exports = __webpack_public_path__ + "img/SketchPngda3eea486e87cc06a877d6b47553360051dc20897203d0315d3568f1b70d5db6.187eb982.png";